<template>
  <DetailLayoutFullWidth>
    <template slot="header">
      <base-header-financial-dashboard
        :title="$t('financial_dashboard.verifactu_compliance')"
        @change="handleChangeEvent"
        @refresh="refreshPage"
        @print="printDashboard"
      />
    </template>
    <template slot="main">
      <loading :opacity="darkMode ? 0 : 0.5" :active="isGeneralLoading" :is-full-page="false" :z-index="10" color="var(--primary-DEFAULT)"></loading>
      <div class="print-area mt-2 md:mt-6 space-y-5">
        <!-- Degradado - bg-gradient-to-br from-primary-900 via-primary-800 to-primary-600 -->
        <base-panel class="bg-primary-900 px-6">
          <div class="flex justify-between text-white">
            <div class="flex flex-col">
              <h3 class="text-xl font-bold">{{ $t('financial_dashboard.status_compliance_verifactu') }}</h3>
              <span class="text-sm text-secondary-200 mt-1">{{ $t('financial_dashboard.verifiable_invoice_issuance') }}</span>
            </div>
            <div class="flex flex-col">
              <span class="text-4xl font-bold">{{ $n(percentage, 'percent_decimal')}}</span>
              <span class="text-sm text-secondary-100">{{ $t('financial_dashboard.compliance_rate') }}</span>
            </div>
          </div>
        </base-panel>
        <div class="flex flex-wrap gap-4">
          <single-panel class="w-full flex-1 min-w-max" :header="$t('financial_dashboard.sent_successfully')" :content="$n(desgloseGeneral.Correctas, 'integer_group')">
            <template slot="header">
              <base-dot-icon class="text-primary-800 dark:text-primary-400" :style="{ color: successColor }"/>
            </template>
            <template slot="footer">
              <span v-safe-html="$tc('invoices.total_invoices_highlighted', this.facturasTotales, { class: 'font-semibold text-primary-800 dark:text-primary-400' }, 'integer_group')" />
            </template>
          </single-panel>
          <single-panel class="content-red-500 w-full flex-1 min-w-max" :style="{ color: wrongColor }" :header="$t('financial_dashboard.with_errors_rejected')" :content="$n(desgloseGeneral.Incorrectas, 'integer_group')" :footer="$t('financial_dashboard.requires_inmediate_attention')">
            <template slot="header">
              <base-dot-icon class="text-red-500 dark:text-red-400" :style="{ color: wrongColor }"/>
            </template>
          </single-panel>
          <single-panel class="content-yellow-500 w-full flex-1 min-w-max" :header="$t('financial_dashboard.pending_shipment')" :content="$n(desgloseGeneral.Pendientes, 'integer_group')" :footer="$t('financial_dashboard.in_processing_queue')">
            <template slot="header">
              <base-dot-icon class="text-yellow-500 dark:text-yellow-400" :style="{ color: pendingColor }"/>
            </template>
          </single-panel>
        </div>
        <div class="grid xl:grid-cols-2 grid-cols-1 gap-4">
          <base-panel>
            <template slot="header">
              <div class="flex flex-wrap justify-between gap-4">
                <h3>{{ $t('financial_dashboard.shipping_by_order_type') }}</h3>
                <div v-if="false" class="m-auto flex flex-wrap gap-5 justify-center text-secondary-500 dark:text-darkblue-100 text-sm">
                  <span 
                  @click="toggleDatasetChart(refPanelChartEnvios,0)" 
                  class="flex items-center gap-2 cursor-pointer" 
                  :style="{ textDecoration: isDatasetHidden(refPanelChartEnvios, 0) ? 'line-through' : 'none' }">
                    <base-dot-icon :style="{ color: successColor }" />
                    <span>{{ $t('verifactu.state.succes') }}</span>
                  </span>
                  <span 
                  @click="toggleDatasetChart(refPanelChartEnvios,1)" 
                  class="flex items-center gap-2 cursor-pointer" 
                  :style="{ textDecoration: isDatasetHidden(refPanelChartEnvios, 1) ? 'line-through' : 'none' }">
                    <base-dot-icon :style="{ color: wrongColor }" />
                    <span>{{ $t('verifactu.state.wrong') }}</span>
                  </span>
                  <span 
                  @click="toggleDatasetChart(refPanelChartEnvios,2)" 
                  class="flex items-center gap-2 cursor-pointer" 
                  :style="{ textDecoration: isDatasetHidden(refPanelChartEnvios, 2) ? 'line-through' : 'none' }">
                    <base-dot-icon :style="{ color: pendingColor }" />
                    <span>{{ $t('verifactu.state.pending') }}</span>
                  </span>
                </div>
              </div>
            </template>
            <template slot="content">
              <Chart id="chart-panel-envios" 
                :ref="refPanelChartEnvios"
                type="bar"
                :show-legend="true"
                :stacked="false"
                :expand="true"
                :charData="chartBarDataEnvios"
                tooltip-value-format="integer_group"
                y-axis-value-format="decimal_group"
              />
            </template>
          </base-panel>
          <base-panel>
            <template slot="header">
              <div class="flex flex-wrap justify-between gap-4">
                <h3>{{ $t('financial_dashboard.trend_compliance_rates') }} ({{ dataPeriod }})</h3>
                <div v-if="false" class="m-auto flex flex-wrap gap-5 justify-center text-secondary-500 dark:text-darkblue-100 text-sm">
                  <span 
                  @click="toggleDatasetChart(refPanelChartCumplimiento,0)" 
                  class="flex items-center gap-2 cursor-pointer" 
                  :style="{ textDecoration: isDatasetHidden(refPanelChartCumplimiento, 0) ? 'line-through' : 'none' }">
                    <base-dot-icon class="text-primary" />
                    <span>{{ $t('financial_dashboard.compliance') }}</span>
                  </span>
                </div>
              </div>
            </template>
            <template slot="content">
              <Chart id="chart-panel-cumplimiento" 
                :ref="refPanelChartCumplimiento"
                type="line"
                :show-legend="true"
                :expand="true"
                :charData="chartLineDataCumplimiento"
                :parse-format="formatValueDate"
                :x-axis-value-format="formatChartDate"
                y-axis-value-format="percent_decimal"
              />
            </template>
          </base-panel>
        </div>
        <div class="grid md:grid-cols-2 grid-cols-1 gap-4">
          <base-panel>
            <template slot="header">
              <div class="flex items-center gap-2">
                <base-icon class="text-primary-800" name="link-2" size="sm" />
                <h3>{{ $t('financial_dashboard.digital_fingerprint_chain') }}</h3>
              </div>
            </template>
            <template slot="content">
              <div v-if="fingerprints.length === 0" class="text-secondary-500 dark:text-darkblue-300 italic">
                {{ $t('financial_dashboard.no_fingerprints') }}
              </div>
              <div v-else>
                <base-message-box class="ring-4 border-primary-400 mb-4 w-full min-w-0" icon-name="success" type="info" icon-class="el-icon-success">
                  <template slot="header">
                    <span class="font-semibold">
                      {{ $t('financial_dashboard.verified_string_nobreaks') }}
                    </span>
                  </template>
                  <template slot="content">
                    <span class="break-words">
                      {{ $t('financial_dashboard.last_verified_hash') }} {{ fingerprints[0].NumFactura }} —
                      <span class="whitespace-nowrap">{{ $d(fingerprints[0].Fecha, 'numeric_datetime', { date: '-', datetime: ' ' }) }}</span>
                    </span>
                  </template>
                </base-message-box>
                <base-message-box v-for="fingerprint in fingerprints" :key="fingerprint.Huella" type="info" class="w-full min-w-0">
                  <template slot="content">
                    <div class="flex flex-row flex-wrap items-center justify-between gap-2 w-full min-w-0">
                      <span class="font-semibold shrink-0">{{ fingerprint.NumFactura }}</span>
                      <span class="flex-1 min-w-0 break-all text-sm text-secondary-600 dark:text-darkblue-300">{{ fingerprint.Huella }}</span>
                      <span class="rounded-full px-2.5 py-0.5 bg-black/5 font-bold shrink-0 self-end md:self-auto"> ✓ </span>
                    </div>
                  </template>
                </base-message-box>
              </div>
            </template>
          </base-panel>
          <base-panel>
            <template slot="header">
              <div class="flex items-center gap-2">
                <base-icon class="text-yellow-500 dark:text-yellow-400" name="warning" size="sm" />
                <h3>{{ $t('financial_dashboard.verifactu_incident_log') }}</h3>
              </div>
            </template>
            <template slot="content">
              <div v-if="alerts.length === 0" class="text-secondary-500 dark:text-darkblue-300 italic">
                {{ $t('financial_dashboard.no_incident_detected') }}
              </div>
              <div v-else class="overflow-hidden">
                <base-alert-box v-for="(alert, index) in alerts" :key="index" :title="alert.Titulo" :text-content="alert.Detalle" :date="alert.Fecha" :type="alert.alertType" :actions="alert.actions" />
              </div>
            </template>
          </base-panel>
        </div>
      </div>
    </template>
   </DetailLayoutFullWidth>
</template>

<script>
import { i18n } from '@/i18n'
import moment from 'moment'

import colorsMixin from '@/mixins/colorsMixin'

import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import Loading from 'vue-loading-overlay'
import SinglePanel from '@/components/SinglePanel.vue'
import Chart from '@/components/charts/Chart.vue'

import { getDashboardFinancieroVerifactu } from '@/services/dashboard/getDashboardFinancieroVerifactu'

export default {
  name: 'verifactu-financial-dashboard',
  mixins: [colorsMixin],
  components: {
    DetailLayoutFullWidth,
    Loading,
    SinglePanel,
    Chart
  },
  data () {
    return {
      refPanelChartEnvios: 'panelChartEnvios',
      refPanelChartCumplimiento: 'panelChartCumplimiento',
      data: [],
      fingerprints: [],
      chartBarDataEnvios: null,
      chartLineDataCumplimiento: null
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    darkMode: function () {
      return this.$store.getters['app/darkMode']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    activePeriod () {
      return this.$store.getters['financialdashboard/activePeriod']
    },
    cifEmpresa () {
      return this.$store.getters['financialdashboard/cifEmpresa']
    },
    valueDate () {
      return this.$store.getters['financialdashboard/valueDate']
    },
    currentFormat () {
      return this.$store.getters['financialdashboard/currentFormat']
    },
    activePeriods: function () {
      return this.$store.getters['config/ACTIVE_PERIODS']
    },
    dataPeriod () {
      return this.activePeriods.find(p => p.id === this.activePeriod)?.timePeriod ?? this.activePeriod
    },
    dataPerPeriod () {
      let picker = this.valueDate 
      if (this.activePeriod ==='semana') {
        picker = moment(picker).format('[Semana] W')
      }
      if (!picker) {
        return this.data.at(-1)
      }
      return this.data.find((p) => p.Fecha === picker)
    },
    percentage () {
      return this.dataPerPeriod?.TasaCumplimiento ?? 0
    },
    desgloseGeneral () {
      return this.dataPerPeriod?.DesgloseGeneral ?? { Correctas: 0, Incorrectas: 0, Pendientes: 0 }
    },
    facturasTotales () {
      return this.desgloseGeneral.Correctas + this.desgloseGeneral.Incorrectas + this.desgloseGeneral.Pendientes
    },
    desgloseTipoRegistro () {
      return this.dataPerPeriod?.DesgloseTipoRegistro ?? []
    },
    alerts () {
      return this.dataPerPeriod?.AlertasVerifactu ?? []
    },
    enabledDates () {
      return this.data.map(df => df.Fecha)
    },
    isDatasetHidden () {
      return this.$store.getters['financialdashboard/isDatasetHidden']
    },
    formatChartDate () {
      return this.currentFormat.i18nFormat || this.currentFormat.momentDate
    },
    formatValueDate () {
      return this.currentFormat.momentValueDate
    },
    successColor () {
      return this.getColor(this.tiposEstadoVerifactu.find(x => x.id === 1)?.color) ?? '#000000'
    },
    wrongColor () {
      return this.getColor(this.tiposEstadoVerifactu.find(x => x.id === 3)?.color) ?? '#000000'
    },
    pendingColor () {
      return this.getColor(this.tiposEstadoVerifactu.find(x => x.id === 4)?.color) ?? '#000000'
    },
    tiposVerifactu () {
      return this.$store.getters['config/TIPOS_VERIFACTU_DASHBOARD']
    },
    tiposEstadoVerifactu () {
      return this.$store.getters['config/TIPOS_ESTADO_VERIFACTU_DASHBOARD']
    },
    tiposAlerta () {
      return this.$store.getters['config/TIPOS_ALERTA']
    },
    tiposAviso () {
      return this.$store.getters['config/TIPOS_AVISO']
    },
  },
  methods: {
    getVerifactuData (item) {
      const data = {
        Fecha: item.Fecha,
        TasaCumplimiento: item.TasaCumplimiento,
        DesgloseGeneral: {
          Correctas: item.VerifactuDesgloseGeneral?.Correctas ?? 0,
          Incorrectas: item.VerifactuDesgloseGeneral?.Incorrectas ?? 0,
          Pendientes: item.VerifactuDesgloseGeneral?.Pendientes ?? 0,
        },
        DesgloseTipoRegistro: [],
        AlertasVerifactu: [],
      }
      if (item.VerifactuDesgloseTipo) {
        for (const tipoRegistro of item.VerifactuDesgloseTipo) {
          data.DesgloseTipoRegistro.push({
            Tipo: tipoRegistro.Tipo,
            TipoLabel: this.tiposVerifactu.find(x => x.id === tipoRegistro.Tipo)?.name ?? tipoRegistro.Tipo,
            Correctas: tipoRegistro.Correctas ?? 0,
            Incorrectas: tipoRegistro.Incorrectas ?? 0,
            Pendientes: tipoRegistro.Pendientes ?? 0,
          })
        }
      }
      if (item.AlertasVerifactu) {
        for (const alerta of item.AlertasVerifactu) {
          data.AlertasVerifactu.push(this.getAlertData(alerta))
        }
      }

      return data
    },
    getAlertData (item) {
      const alert = this.tiposAlerta.find(x => x.id === item.ImportanciaAlerta)
      const aviso = this.tiposAviso.find(x => x.TipoAviso === item.TipoAlerta)
      const alertData = {
        Titulo: ((aviso?.Mensaje) ?? item.TipoAlerta) + (item.TipoAlerta === 7 ? item.Titulo : ''),
        Detalle: (item.TipoAlerta === 7 ? item.Detalle : (`${aviso?.Mensaje ?? ''} (${item.Detalle})`).trim()) ?? '',
        Ruta: item.Ruta,
        TipoAlerta: item.TipoAlerta,
        ImportanciaAlerta: item.ImportanciaAlerta,
        alertType: alert?.alertType ?? 'error',
        Fecha: item.Fecha,
        actions: []
      }
      if (alertData.Ruta) {
        const privateBase = `${process.env.VUE_APP_ROUTE_BASE}`
        alertData.actions.push({
          text: i18n.tc('app.see_alerts', 1),
          type: 'link',
          route: item.TipoAlerta === 7 ? { path: `/${privateBase}/${item.Ruta}` } : { name: item.Ruta },
          target: '_blank'
        })
      }
      return alertData
    },
    getFingerprintData (item) {
      return {
        Fecha: item.Fecha,
        Huella: item.Huella,
        NumFactura: item.NumFactura
      }
    },
    handleChangeEvent ({ field, value, refresh }) {
      if (refresh) {
        if (field !== 'valueDate' || !this.enabledDates.includes(value)) {
          this.refreshPage()
        } else {
          setTimeout(() => {
            this.loadChartDataEnvios()
            // this.loadChartDataCumplimiento()
          }, 100)
        }
      }
    },
    async refreshPage () {
      try {
        this.$store.commit('setIsLoading', true)
        const unitTime = this.$store.getters['financialdashboard/momentTimeUnit']
        const params = {
          idCifEmpresa: this.cifEmpresa?.IdCIFEmpresa ?? null,
          fechaFiltro: this.activePeriod,
          FechaFin: moment(this.valueDate, this.currentFormat.momentValueDate).startOf('day').endOf(unitTime).format('YYYY-MM-DDT[00:00:00]'),
        }
        const data = await getDashboardFinancieroVerifactu(params)
        this.data = []
        this.fingerprints = []
        if (!data.blnError) {
          if (data.Response) {
            for (const item of data.Response) {
              this.data.push(this.getVerifactuData(item))
            }
          }
          if (data.HuellaVerifactu) {
            for (const item of data.HuellaVerifactu) {
              this.fingerprints.push(this.getFingerprintData(item))
            }
          }
          setTimeout(() => {
            this.loadChartDataEnvios()
            this.loadChartDataCumplimiento()
          }, 100)
        } else {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', data))
        }
      } catch (error) {
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.$store.commit('financialdashboard/resetHiddenDatasets')
    },
    loadChartDataEnvios () {
      this.chartBarDataEnvios = {
        labels: [],
        datasets: [
          {
            label: i18n.t('verifactu.state.succes'),
            data: [],
            backgroundColor: this.successColor,
            // darkBackgroundColor: this.getColor('--primary-500'),
          },
          {
            label: i18n.t('verifactu.state.wrong'),
            data: [],
            backgroundColor: this.wrongColor,
            // darkBackgroundColor: 'red',
          },
          {
            label: i18n.t('verifactu.state.pending'),
            data: [],
            backgroundColor: this.pendingColor,
            // darkBackgroundColor: 'yellow',
          }
        ]
      }
      this.tiposVerifactu.forEach(tipoRegistro => {
        this.chartBarDataEnvios.labels.push(tipoRegistro.name)
        const desgloseTipo = this.desgloseTipoRegistro.find(x => x.Tipo === tipoRegistro.id) || { Correctas: 0, Incorrectas: 0, Pendientes: 0 }
        this.chartBarDataEnvios.datasets[0].data.push(desgloseTipo.Correctas)
        this.chartBarDataEnvios.datasets[1].data.push(desgloseTipo.Incorrectas)
        this.chartBarDataEnvios.datasets[2].data.push(desgloseTipo.Pendientes)
      })
    },
    loadChartDataCumplimiento () {
      this.chartLineDataCumplimiento = {
        labels: [],
        datasets: [
          {
            label: i18n.t('financial_dashboard.compliance'),
            data: [],
            borderColor: this.getColor('--primary-DEFAULT'),
            backgroundColor: this.getColor('--primary-DEFAULT'),
            fill: false,
          }
        ]
      }
      this.data.forEach(element => {
        this.chartLineDataCumplimiento.labels.push(element.Fecha)
        this.chartLineDataCumplimiento.datasets[0].data.push(element.TasaCumplimiento)
      })
    },
    toggleDatasetChart (refChart, datasetIndex) {
      this.$store.commit('financialdashboard/toggleHiddenDataset', { refChart, datasetIndex })
      this.$refs[refChart].toggleDatasetVisibility(datasetIndex)
    },
    printDashboard () {
      const printArea = this.$el.querySelector('.print-area')
      if (!printArea) return

      const oldIframe = document.getElementById('printeriframe')
      if (oldIframe) oldIframe.remove()

      const clone = printArea.cloneNode(true)
      const originalCanvas = printArea.querySelectorAll('canvas')

      const linkWarning = clone.getElementsByTagName('a')
      if (linkWarning) Array.from(linkWarning).forEach(link => link.remove())
      
      const chartRefs = {
        'chart-chart-panel-envios': this.refPanelChartEnvios,
        'chart-chart-panel-cumplimiento': this.refPanelChartCumplimiento,
      }

      clone.querySelectorAll('canvas').forEach((cloneCanvas, index) => {
        if (originalCanvas[index]) {
          const chartId = originalCanvas[index].id
          const chartRef = this.$refs[chartRefs[chartId]]
          const sourceCanvas = chartRef?.trimCanvas() || originalCanvas[index]
          const img = document.createElement('img')
          img.src = sourceCanvas.toDataURL('image/png')
          img.style.width = this.isLower1024 ? '65%' : '100%'
          img.style.justifySelf = 'center'
          img.style.alignSelf = 'center'
          cloneCanvas.parentNode.replaceChild(img, cloneCanvas)
        }
      })

      const iframe = document.createElement('iframe')
      iframe.setAttribute('id', 'printeriframe')
      iframe.setAttribute('width', '768px')
      iframe.style.display = 'none'
      document.body.appendChild(iframe)

      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document

      const allStyles = [...document.querySelectorAll('link[rel="stylesheet"], style')]
        .map(el => el.outerHTML).join('\n')

      iframeDoc.open()
      iframeDoc.write(`<!DOCTYPE html><html><head><meta charset="utf-8">${allStyles}</head><body>${clone.outerHTML}</body></html>`)
      iframeDoc.close()

      const printStyle = iframeDoc.createElement('style')
      printStyle.textContent = `
        @page { 
          size: A4; 
          margin: 10mm;
        }
        @media print {
          .print-area { 
            shadow: none !important; 
          }
          .kpi-card {
              break-inside: avoid;
              page-break-inside: avoid;
          }
        }
        *, *::before, *::after { 
          box-sizing: border-box; 
        }
        html, body {
          width: 100%;
          height: auto;
          margin: 0;
          padding: 0;
          overflow: visible;
          background: white;
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .print-area {
          width: 100%;
          padding: 0;
          margin: 0;
        }
        `
      iframeDoc.head.appendChild(printStyle)

      setTimeout(() => {
        try {
          iframe.contentWindow.focus()
          iframe.contentWindow.print()
        } catch (e) {
          console.error('Error al imprimir:', e)
        }
        setTimeout(() => iframe.remove(), 1000)
      }, 300)
    },
  }
}
</script>
<style>
@media (min-width: 1280px) {
    .xl\:hidden {
        display: none;
    }
    .xl\:inline {
        display: inline;
    }
}
</style>
